"use client";
import { useFlag } from "@/lib/useFlag";
import V1 from "./_v1/FinanzenPayslipV1";
import V2 from "./_v2/FinanzenPayslipV2";
export default function Flip() { return useFlag("redesign.finanzen.payslip", false) ? <V2 /> : <V1 />; }
